module.exports = __webpack_public_path__ + "img/bjorn-bylund-quote-image.661da344.png";